export default __webpack_public_path__ + "static/media/Icon.2b0a5fac.png";